<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2
          class="pl-2"
        >{{ editRoute ? $t('labels.edit_consequence') : $t('labels.add_consequence') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full p-0">
              <label>{{ $t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="consequence_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.consequence_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('consequence_name') }}</span>
            </div>
            <div class="vx-col sm: w-full p-0 sm: mt-6 md:mt-6">
              <label>{{ $t('labels.mitigating_barriers')}}</label>
              <v-select
                multiple
                name="mitigating_barrier"
                v-model="parent_id"
                :options="parentSection"
                :reduce="parentSection => parentSection.id"
                label="name"
                :closeOnSelect="false"
                class="mt-1"
              />
              <span class="text-danger text-sm">{{ errors.first('mitigating_barrier') }}</span>
            </div>
          </div>
          <div class="mt-6 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-consequence"
              button="submit"
            >{{ editRoute ? $t('labels.update_consequence') : $t('labels.add_consequence') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      parentSection: [],
      parent_id: []
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.getMitigatingBarrier();
    this.setValidationMessage();
    if (this.editRoute) {
      this.getConsequence();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateConsequences();
        }
      });
    },
    // API Integration for add-update designation
    async createUpdateConsequences() {
      let input = {
        name: this.name,
        mitigating_barrier_ids: this.parent_id
      };
      let url = this.editRoute
        ? "/consequences/update/" + this.editRoute
        : "/consequences/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-consequence",
        true
      );
      if (response) {
        this.$router.push({ name: "Consequences" });
      }
    },
    async getConsequence() {
      let response = await this.getHTTPGetResponse(
        "/consequences/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let consequence = data.consequence;
        this.name = consequence.name;
        let filteredSection = [];
        for (var i = 0; i < consequence.mitigating_barriers.length; i++) {
          filteredSection.push(consequence.mitigating_barriers[i].id);
        }
        this.parent_id = filteredSection;
      }
    },
    async getMitigatingBarrier() {
      let input = {
        name: this.parent_id
      };
      let response = await this.getHTTPPostResponse(
        "/mitigating-barriers/list",
        input
      );
      if (response) {
        let mitigating_req = response.data.mitigating_barriers;
        let filteredSection = [];
        for (var i = 0; i < mitigating_req.length; i++) {
          let obj = { id: mitigating_req[i].id, name: mitigating_req[i].name };
          filteredSection.push(obj);
        }
        this.parentSection = filteredSection;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>